<template>
    <v-dialog v-model="dialog" max-width="450">
        <template v-slot:activator="{ on }">
            <v-btn text v-on="on">
                <v-icon>mdi-folder-open</v-icon>
                Sessions
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
            </v-card-title>
            <v-card-text>
                <v-list>
                    <v-list-item v-for="s in sessions" :key="s.uuid" @click="selectItem(s)">
                        <v-list-item-content >
                            <v-list-item-title>{{s.name}}</v-list-item-title>
                            <v-list-item-subtitle>{{s.description}}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-card-text>
            <v-card-actions>
                <v-btn text @click="Close()"><v-icon>{{icons.close}}</v-icon> Close</v-btn>
                <v-spacer></v-spacer>
                <AddSession @saved="getSessions()" />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'
  import AddSession from "@/views/notes/AddSession";

  export default {
    name: "NoteSessions",
    components: {AddSession},
    data() {
      return {
        dialog: false,
        sessions: undefined
      }
    },
    computed: {
      ...mapState(['icons'])
    },
    watch:{
      dialog(n,o){
        if(n){
          this.getSessions()
        }
      }
    },
    methods: {
      ...mapActions(['get', 'post']),
      async getSessions(){
        this.sessions = await this.get({path: 'api/notes/sessions'})
      },
      selectItem(item){
        this.$emit('selected', item)
        this.dialog=false
      },
      Close() {
        this.dialog = false
      }
    }
  }
</script>

<style scoped>

</style>